import { SEARCH_MODAL_ITEM_KIND } from '@common/components/SearchModal/search-modal.const'

import type { AcademySearchApiItem } from '@/lib/academySearch/academySearch.interface'
import { buildDocumentationHref } from '@/shared/docs-shared.utils'

import { buildSearchModalSubtitle, buildSearchResultHref } from '../search-modal.utils'

export function mapDocumentation(row: AcademySearchApiItem, queryTrimmed: string) {
  return {
    id: `doc-${row.path}`,
    title: row.title,
    href: buildSearchResultHref(buildDocumentationHref(row.slug), queryTrimmed, row.headingId),
    shortDescription: buildSearchModalSubtitle(row.description, row.snippet, queryTrimmed),
    category: row.categoryDisplay.trim() !== '' ? row.categoryDisplay : undefined,
    kind: SEARCH_MODAL_ITEM_KIND.Documentation,
  }
}
